import { lazy, Suspense } from 'react'
import { useParams } from 'react-router-dom'
import { canAccessModel, useAccessStore } from '@/services/access'
import { getWorldObjectById } from '@/services/landmarks'

const UpgradeGate = lazy(() => import('./UpgradeGate').then((module) => ({ default: module.UpgradeGate })))

/** Keeps the public model URL crawlable while limiting the interactive viewer. */
export function ModelAccessBoundary({ children }: { children: React.ReactNode }) {
  const { id } = useParams<{ id: string }>()
  const entitlementState = useAccessStore((state) => state.entitlementState)
  const hasFullAccess = useAccessStore((state) => state.hasFullAccess)
  const allowed = Boolean(id && canAccessModel(id))

  if (allowed || hasFullAccess) return <>{children}</>
  if (entitlementState === 'loading') {
    return <main className="grid min-h-full place-items-center bg-[#04050f] text-white"><p>Loading account…</p></main>
  }
  return <Suspense fallback={<div className="min-h-full bg-[#04050f]" />}><UpgradeGate worldObject={id ? getWorldObjectById(id) : undefined} surface="model" /></Suspense>
}
